import axios from 'axios';

import { GEORGIA_TIMEZONE } from '../constants/georgiaTimezone';

export function configureGeorgiaTimezone(store) {
	axios.interceptors.request.use((config) => {
		if (config.headers) {
			config.headers.Timezone = GEORGIA_TIMEZONE;
		}

		return config;
	});

	store.commit('setHttpRequestHeaders', { timezone: GEORGIA_TIMEZONE });
}
